import { render, staticRenderFns } from "./UserReg.vue?vue&type=template&id=5cf4e766&scoped=true"
import script from "./UserReg.vue?vue&type=script&lang=js"
export * from "./UserReg.vue?vue&type=script&lang=js"
import style0 from "./UserReg.vue?vue&type=style&index=0&id=5cf4e766&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4e766",
  null
  
)

export default component.exports